<template>
	<div class="flex py-2 flex-row px-5 items-center gap-3" @click="toggle()">
		<div class="text-xl">
			<i class="far fa-circle cursor-pointer" v-if="displayCheck && !checked"></i>
			<i class="far fa-circle-check cursor-pointer" v-if="displayCheck && checked"></i>
		</div>
		<div class="flex flex-col lg:flex-grow">
			<div class="flex flex-col lg:flex-grow">
				<p class="flex flex-col">
					<span :class="{ 'line-through': !displayCheck && checked }">{{ reminder.comment }}</span>
				</p>
			</div>
			<div class="flex flex-col justify-center text-blue-400">
				<div
					v-if="reminder.targetable_type === 'contact' && reminder.targetable"
					class="cursor-pointer flex gap-1 items-center"
					@click.prevent="router.get(route('contacts.get', { contact: reminder.targetable_id }))">
					<i class="far fa-user"></i>
					{{ reminder.targetable.first_name }} {{ reminder.targetable.last_name }}
					<span v-if="reminder.targetable.targeted" class="rounded text-blue-500 p-1">
						<i class="fas fa-crosshairs"></i>
					</span>
					-
					<span class="text-xs">
						{{ $d.fromISO(reminder.created_at).toFormat('dd/MM/yy') }}
					</span>
				</div>
				<div
					v-if="reminder.targetable_type === 'structure' && reminder.targetable"
					class="cursor-pointer"
					@click.prevent="router.get(route('structures.get', { structure: reminder.targetable_id }))">
					<i class="far fa-hospital"></i>
					{{ reminder.targetable.name }} -
					<span class="text-xs">
						{{ $d.fromISO(reminder.created_at).toFormat('dd/MM/yy') }}
					</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
	import { ref, onMounted } from 'vue';
	import { router } from '@inertiajs/vue3';
	import { toast } from 'vue3-toastify';
	import axios from 'axios';

	const props = defineProps({
		reminder: {
			type: Object,
			required: true,
			default: () => ({}),
		},
		displayCheck: {
			type: Boolean,
			default: true,
		},
	});

	const emit = defineEmits(['check']);

	const checked = ref(false);

	const toggle = () => {
		if (props.displayCheck) {
			checked.value = !checked.value;
			axios
				.get(route('reminders.toggle', props.reminder.id))
				.then((response) => {
					checked.value = response.data.is_done;
					toast.success('Rappel modifié avec succès !');
					emit('check', props.reminder);
				})
				.catch((error) => {
					toast.error('Une erreur est survenue');
					console.error(error);
					checked.value = !checked.value;
				});
		}
	};

	onMounted(() => {
		checked.value = props.reminder.is_done;
	});
</script>
